var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CScrollbar',{staticClass:"c-sidebar-nav h-100",attrs:{"settings":_vm.psSettings,"switcher":!_vm.state.minimize,"tag":"ul"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }